import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AcceptTransactionDTO } from 'src/app/dashboard/interfaces/accept-transaction.dto';
import { CuentaTrabajo } from 'src/app/dashboard/interfaces/cuenta-trabajo.interface';
import { TransferenciasUSDT } from 'src/app/dashboard/interfaces/transferencia-usdt.interface';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { WorkingAccountService } from 'src/app/dashboard/services/working-account.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-send-transactions-zelle-modal',
  templateUrl: './send-transactions-zelle-modal.component.html',
  styleUrls: ['./send-transactions-zelle-modal.component.sass']
})
export class SendTransactionsZelleModalComponent {

  transaction: TransferenciasUSDT | undefined;
  datosForm: FormGroup | undefined;
  cuentasTrabajo: CuentaTrabajo[] = [];
  cuentaSeleccionada: number | undefined;
  cuentaTrabajo: CuentaTrabajo | undefined;
  countryCode = 'US';

  constructor(
    private spinner: SpinnerService,
    private readonly transactionService: TransaccionService,
    public dialogRef: MatDialogRef<SendTransactionsZelleModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private workingAccountService: WorkingAccountService){
    this.transaction = data;
    this.getWorkingAccounts();
    this.initForm();
  }


  initForm(){
    this.datosForm = this.fb.group({
      referencia: new FormControl(''),
      cuentaSeleccionada: ['', Validators.required]
    });
  }

  close(){
    this.dialogRef.close();
  }

  async getWorkingAccounts() {
    this.cuentasTrabajo = (await this.workingAccountService.getWorkingAccounts([this.countryCode]))
  }

  async acceptTransaction(){
    if(this.datosForm?.invalid || !this.transaction?.idTransferencia)return;
    const spinnerRef = this.spinner.start();

    const payload: AcceptTransactionDTO = {
      transactionID: Number(this.transaction?.idTransferencia),
      referencia: this.datosForm?.get('referencia')?.value,
      cuentaTrabajoID: this.datosForm?.get('cuentaSeleccionada')?.value
    }
    try{
      const result =  await this.transactionService.acceptTransaction(payload);
      Swal.fire({
        icon: 'success',
        title: 'Transacción pagada',
        text: 'la transacción se ha pagado exitosamente',
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',

      });
      this.dialogRef.close(true);
    }catch(error: any){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.error.mensaje,
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',

      });
      this.dialogRef.close(true);
    }

    this.spinner.stop(spinnerRef);
  }



}
